import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { HorseshoeIcon } from './HorseshoeIcon';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { stable } from '../data/stable';
export function Header() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  const links = [{
    href: '#stable',
    label: t.nav.stable
  }, {
    href: '#horses',
    label: t.nav.horses
  }, {
    href: '#rides',
    label: t.nav.rides
  }, {
    href: '#events',
    label: t.nav.events
  }, {
    href: '#rules',
    label: t.nav.rules
  }];
  return <header className="sticky top-0 z-40 border-b border-line bg-cream/95 backdrop-blur" data-id="element-155" data-mp="36as5ki6k6ygs">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 lg:px-8" data-id="element-156" data-mp="3baelx0hooutt">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap font-serif text-xl font-bold text-bark" data-id="element-157" data-mp="3fbgmplr91exw">
          <HorseshoeIcon className="h-8 w-8 -translate-y-px text-saddle" data-id="element-158" data-mp="2wl4gasn3kah9" />
          {stable.name}
        </a>

        <nav className="hidden items-center gap-7 xl:flex" aria-label="Main" data-id="element-159" data-mp="2rkq5j2u42mfj">
          {links.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[15px] font-medium text-bark/75 transition-colors duration-150 hover:text-bark" data-id="element-160" data-mp="2mngb18rv7kku">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-161" data-mp="3adakdgcz6r0c">
          <LanguageSwitcher data-id="element-162" data-mp="3aelq3lpze8u3" />
          <a href="#booking" className="hidden whitespace-nowrap rounded-full bg-saddle px-4 py-2 text-sm font-bold text-cream transition-colors duration-150 hover:bg-leather sm:inline-flex" data-id="element-163" data-mp="35l10oi2gen6i">
            {t.nav.book}
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={t.nav.menu} className="rounded-md p-2 text-bark xl:hidden" data-id="element-164" data-mp="1yafogwgmv8a">
            {open ? <XIcon className="h-5 w-5" data-id="element-165" data-mp="1wbuvsithy2gw" /> : <MenuIcon className="h-5 w-5" data-id="element-166" data-mp="1hnru3lmhlcxw" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-167" data-mp="1hlxe8lq2ob0o">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-cream px-5 py-4 xl:hidden" data-id="element-168" data-mp="1mltatzwfx067">
            <ul className="space-y-1" data-id="element-169" data-mp="13nqppw70jndo">
              {[...links, {
            href: '#booking',
            label: t.nav.booking
          }].map(link => <li key={link.href} data-id="element-170" data-mp="2t3yjxsgwrofl">
                  <a href={link.href} onClick={() => setOpen(false)} className="block rounded-md px-2 py-2.5 font-medium text-bark hover:bg-linen" data-id="element-171" data-mp="2t0u7k7tahmdu">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}